import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelComponentTypeList from './ModelComponentTypeList';
import { getUserProfileWidget, getModelComponentType, getUserOrgModelCategoryType } from '../../selectors/index';

import {
  getModelComponentTypeThunk,
  saveModelComponentTypeThunk,
  setModelComponentTypeChangeThunk,
  setCurrentPage,
  setPageFilter,
  setModelComponentTypeFilteredDataThunk,
  resetModelComponentThunk
} from '../../actions/modelComponentTypes';

const mapStateToProps = state => {
  return {
    modelComponentType: getModelComponentType(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      getModelComponentType: (offset, limit, filter, modelCategoryId) => getModelComponentTypeThunk({ offset, limit, filter }, modelCategoryId, 'MODELCOMPONENTTYPE_LIST'),
      saveModelComponentType: (modelComponentType, widgetCode) => saveModelComponentTypeThunk(modelComponentType, widgetCode),
      setModelComponentTypeChange: selectedModelComponentType => setModelComponentTypeChangeThunk(selectedModelComponentType),
      setFilterData: filteredData => setModelComponentTypeFilteredDataThunk(filteredData),
      resetModelComponent: initialData => resetModelComponentThunk(initialData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelComponentTypeList);
